import {populateCommentComments} from "./populateCommentComments";

export function showSubComments(id, count) {
    if (shownCommentComments[id] === undefined) {
        shownCommentComments[id] = 0;
    }
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_comment_comments",
        datatype: "json",
        data: {
            "ajax_call_id": id,
            "ajax_call_count": count,
            "ajax_call_shown_comments": shownCommentComments[id]
        },
        success: function (output) {
            if (output !== "false") {
                populateCommentComments(id, output);
            }
        }
    });
}